import React from 'react';
import { Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';

import { StyledLinkedTable } from '../../common/tableView.styles';
import { LinkTableCell } from '../../components/LinkTableCell';
import { StyledRow } from '../../components/StyledRow';
import Icon from '../../icons/Icon';
import { PageRoutesEnum } from '../../utils/routes';
import { ClientProject } from '../clients/Clients.types';

type ClientProjectRow = {
  key: string;
  uuid: string;
  name: string;
};

const renderLinkCell = (text: string, record: ClientProjectRow) => (
  <LinkTableCell text={text} record={record} pageRoute={PageRoutesEnum.projectsEdit} />
);

const columns: ColumnsType<ClientProjectRow> = [
  {
    title: 'Name',
    dataIndex: 'name',
    render: renderLinkCell,
    sorter: {
      compare: () => 1,
      multiple: 1,
    },
  },
];

export const ClientProjectsTable: React.FC<{ projects: ClientProject[] }> = ({ projects }) => {
  const dataSource = projects.map((project) => {
    return {
      key: project.uuid,
      uuid: project.uuid,
      name: project.name,
    };
  });

  const pagination = {
    position: 'bottomCenter',
    hideOnSinglePage: true,
  };
  return (
    <div style={{ paddingBottom: '15px' }}>
      <StyledRow justifyContent="start" style={{ paddingLeft: '15px' }}>
        <Icon name="ProjectsSolid" style={{ color: '#757575', width: '20' }} />
        <Typography.Title level={5}>Projects</Typography.Title>
      </StyledRow>
      <StyledLinkedTable
        columns={columns}
        dataSource={dataSource}
        pagination={pagination}
        scroll={{ y: 700 }}
        bordered
      />
    </div>
  );
};
